<template>

  <v-app>

    <Header v-if="!app.emptyPage"/>

    <v-content v-if="!loaderOverlay">

      <router-view />

    </v-content>

    <v-overlay :value="loaderOverlay">

      <v-progress-circular indeterminate size="64"></v-progress-circular>

    </v-overlay>

    <Footer v-if="!app.emptyPage"/>

  </v-app>

</template>

<style>

.menu_section {
  min-width: 270px;
}

.container_section {
  width: 100%;
  padding-bottom: 50px;
}

.v-card__actions {
  background-color: #f2f2f2;
}

.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
  border-color: rgba(0, 0, 0, 0.12);
}

</style>

<script>

import { mapGetters, mapActions } from "vuex";
import Header from './components/Header' ;
import Footer from './components/Footer' ;

export default {

  components: {
    Header,
    Footer,
  },
  computed: {
    ...mapGetters({
      app: "app/data",
      loaderOverlay: "app/loaderOverlay",
      user: "user/current",
      currentCompany: "companies/currentCompany",
    }),
  },
  data () {
    return {
      show: false
    }
  },
  watch: {

    user(user){

      if(user && this.currentCompany === null && localStorage.currentCompany){
        this.setCompany(JSON.parse(localStorage.currentCompany)) 
      }

    },
    currentCompany(newValue) {

      // Do whatever makes sense now
      if (newValue === null) {
        this.app.emptyPage = true ;
        this.$router.push({ name: "Companies" });
      }else{
        this.app.emptyPage = false ;
        this.$router.push({ name: "Dashboard" });
      }

    },

  },
  methods: {

    ...mapActions({
        setCompany: 'companies/setCompany'
    }),

  },
  created() {

      if(this.loaderOverlay){
        this.app.emptyPage = true ; 
      }else if(!this.user.loggedin){
        this.app.emptyPage = true ; 
      }else{
        this.app.emptyPage = false ; 
      }
      
      if(this.currentCompany === null && !localStorage.currentCompany){
          this.app.emptyPage = true ; 
          this.$router.push({ name: "Companies" });
      }
      
  },

}

</script>